import React from 'react'

interface CaseoptionProps {
  arr: string[];
  filterCaseList: (industry: string) => void;
  activeFilter: string;
}

const Caseoption = ({ arr, filterCaseList, activeFilter }: CaseoptionProps) => {
  return (
    <div className="filter-pills">
      <button
        className={`filter-pill ${activeFilter === '' ? 'filter-pill--active' : ''}`}
        onClick={() => filterCaseList('')}
      >
        All
      </button>
      {arr.map((name, index) => (
        <button
          key={index}
          className={`filter-pill ${activeFilter === name ? 'filter-pill--active' : ''}`}
          onClick={() => filterCaseList(name)}
        >
          {name}
        </button>
      ))}
    </div>
  )
}

export default Caseoption
